import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import AccountConnectionDisplay from './AccountConnectionDisplay';
import { Section } from './styled';

const AccountTabPane = ({
  sources,
  destinations,
  thirdParties,
  thirdPartiesPayoneer,
  thirdPartiesStripe,
  deleteAccount,
  reconnectDestinationAccount,
  showConfirmToDelete,
  showWarning,
  billingPaypalAccountId,
  isPaypalPreferred,
  billingPayoneerAccountId,
  billingStripeAccountId,
  isPayoneerPreferred,
  isStripePreferred,
  editPassword,
  connectGlobal,
  disconnectGlobal,
  isNonApi,
  currency,
}) => (
  <Fragment>
    {sources.length ? (
      <Section>
        <FormattedMessage id="connection.connectedSources" defaultMessage="Connected Sources">
          {txt => <span className="title2">{txt}</span>}
        </FormattedMessage>
        {sources.map(account => (
          <AccountConnectionDisplay
            key={account.id}
            deleteAccount={(...args) =>
              showConfirmToDelete(...args, 'settingsModal.sourceDeleteWarning')
            }
            account={account}
            type="source"
            editPassword={editPassword}
          />
        ))}
      </Section>
    ) : null}
    {destinations.length ? (
      <Section>
        <FormattedMessage
          id="connection.connectedDestinations"
          defaultMessage="Connected Destinations"
        >
          {txt => <span className="title2">{txt}</span>}
        </FormattedMessage>
        {destinations.map(account => (
          <AccountConnectionDisplay
            key={account.id}
            deleteAccount={(...args) =>
              showConfirmToDelete(...args, 'settingsModal.destinationDeleteWarning')
            }
            reconnectAccount={() => {
              reconnectDestinationAccount(account.marketplaceTypeId);
            }}
            account={account}
            connectGlobal={connectGlobal}
            disconnectGlobal={disconnectGlobal}
            currency={currency}
            type="destination"
            isNonApi={isNonApi}
          />
        ))}
      </Section>
    ) : null}

    {thirdParties.length || thirdPartiesPayoneer.length || thirdPartiesStripe.length ? (
      <Section>
        <FormattedMessage
          id="connection.connectedThirdParties"
          defaultMessage="Connected Third Parties"
        >
          {txt => <span className="title2">{txt}</span>}
        </FormattedMessage>
        {thirdParties.map(account => (
          <AccountConnectionDisplay
            key={account.id}
            deleteAccount={
              billingPaypalAccountId === account.id && isPaypalPreferred
                ? showWarning
                : deleteAccount
            }
            account={account}
            type="paypal"
            isDefault={billingPaypalAccountId === account.id && isPaypalPreferred}
          />
        ))}
        {thirdPartiesPayoneer.map(account => (
          <AccountConnectionDisplay
            key={account.id}
            deleteAccount={
              billingPayoneerAccountId === account.id && isPayoneerPreferred
                ? showWarning
                : deleteAccount
            }
            account={account}
            type="payoneer"
            isDefault={billingPayoneerAccountId === account.id && isPayoneerPreferred}
          />
        ))}
        {thirdPartiesStripe.map(account => (
          <AccountConnectionDisplay
            key={account.id}
            deleteAccount={
              billingStripeAccountId === account.id && isStripePreferred
                ? showWarning
                : deleteAccount
            }
            account={account}
            type="stripe"
            isDefault={billingStripeAccountId === account.id && isStripePreferred}
          />
        ))}
      </Section>
    ) : null}
  </Fragment>
);

AccountTabPane.propTypes = {
  sources: PropTypes.array,
  destinations: PropTypes.array,
  thirdParties: PropTypes.array,
  deleteAccount: PropTypes.func,
  reconnectDestinationAccount: PropTypes.func,
  showConfirmToDelete: PropTypes.func,
  editPassword: PropTypes.func,
  showWarning: PropTypes.func,
  billingPaypalAccountId: PropTypes.string,
  isNonApi: PropTypes.bool,
};

export default observer(AccountTabPane);
